<template>
	<div v-if="errorMessage != ''">
		<div v-if="errorMessage == 'not-found'">
			<ReportSubmittedNotFound :id="id" />
		</div>
		<div v-else>
			<p>{{ errorMessage }}</p>
		</div>
	</div>
	<div v-else-if="report">
		<ReportSubmitted :report="report" />
	</div>
	<div v-else>
		<p>Loading...</p>
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";

import { ErrorClient } from "@/client";
import { log } from "@/log";
import ReportSubmitted from "@/rmo/content/ReportSubmitted.vue";
import ReportSubmittedNotFound from "@/rmo/content/ReportSubmittedNotFound.vue";
import { useStorePublicReport } from "@/rmo/store/publicreport";
import type { District, PublicReport } from "@/type/api";

interface Props {
	id: string;
}

const errorMessage = ref("");
const props = defineProps<Props>();
const report = computed((): PublicReport | undefined => {
	return storePublicReport.byID.get(props.id);
});
const storePublicReport = useStorePublicReport();
onMounted(async () => {
	try {
		const report = await storePublicReport.fetchByID(props.id);
		log.info("report", report);
	} catch (e: any) {
		if (e instanceof ErrorClient) {
			if (e.status == 404) {
				errorMessage.value = "not-found";
			}
		} else if (e instanceof Error) {
			errorMessage.value = e.message;
		} else {
			errorMessage.value = "Something went wrong.";
		}
	}
});
</script>
